
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { ServicesRepository } from "../../repositories";
import { Observable } from 'rxjs';
import { TransportServiceRequest } from '../../domain';

@Injectable({ providedIn: 'root' })
export class AddEditTransportServiceUsecase implements UseCase<TransportServiceRequest[], boolean> {

  constructor(private readonly serviceRepository: ServicesRepository) {
  }

  execute(params: TransportServiceRequest[]): Observable<boolean> {
    return this.serviceRepository.addEditTransportService(params);
  }

}
